export const MERCHANT = {
    get: "/store",
    patch: "/store",
    updateImage: "/store/image"
  };
  